import { AbstractControl, ValidationErrors } from '@angular/forms';
import { emailRegex } from './regex';
//SCS-99a: Emails with an apostrophe (') in aren't being accepted
export const emailValidator = (control: AbstractControl): ValidationErrors | null => {
    return !control.value || emailRegex.test(control.value)
    ? null
    : { email: true };
//SCS-99a: Emails with an apostrophe (') in aren't being accepted
    /*return !control.value || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(control.value)
        ? null
        : { email: true };*/
};
export const nationalInsuranceNumberValidator = (control: AbstractControl): ValidationErrors | null => {
    return !control.value ||
        /^[A-CEGHJ-PR-TW-Z]{1}[A-CEGHJ-NPR-TW-Z]{1}[0-9]{6}[A-D\s]{0,1}$/.test(control.value.toUpperCase())
        ? null
        : { nationalInsuranceNumber: true };
};
// SCS-86: INI file setting SuppressNinoValidation=true is not working on new front end
export const nationalInsuranceNumberNoCheckValidator = (control: AbstractControl): ValidationErrors | null => {
    return !control.value ||
    control.value ? null : null
};
// SCS-86: INI file setting SuppressNinoValidation=true is not working on new front end